import api from "api/api";
import { fetchWithResilience } from "services/apiResilience";

export const login = async (username, password) =>
  await api.post("/auth/login", { username, password });

export const getSSOJwt = async (token) =>
  await api.post("/auth/sso", { token });

export const mascaradeAsQuery = async (email) =>
  await api.post(`/auth/mascarade/${email}`);

export const postUserFiltersQuery = async (filters) =>
  await fetchWithResilience(
    () => api.post("/storage/key-value/", filters),
    "storage-module"
  );

export const getUserFiltersQuery = async (key) =>
  await fetchWithResilience(
    () => api.get(`/storage/key-value/${key}`),
    "storage-module"
  );
